<template>
  <UiBaseGridDesk
    v-if="data.acf_fields"
    :cards="data.acf_fields.shop_guid"
    :changedMargin="false"
    :title="title"
    :subtitle="'Master your style: curated trend features and styling insights.'"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: {
    acf_fields: {
      txt_1: string
      txt_2: string
      shop_guid: Card[]
    }
  }
}>()

const title: Title = {
  first: props.data.acf_fields.txt_1,
  second: props.data.acf_fields.txt_2
}
</script>

<style lang="scss" module></style>
